import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import PieSlice from '../../common-components/ECharts/PieSlice3D.jsx';
import "./style.scss";
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";


const PieChart3D = ({ data, onSliceClick, onLabelClick }) => {

  const cameraRef = useRef();


  const radius = 3.5;
  const height = 1;
  const [enabledSlices, setEnabledSlices] = useState(data.map(() => true));

  const toggleSlice = (index) => {
    setEnabledSlices((prev) =>
      prev.map((enabled, i) => (i === index ? !enabled : enabled))
    );
  };

  const activeData = data.filter((_, index) => enabledSlices[index]);
const activeTotal = activeData.reduce((sum, item) => sum + item.value, 0);
{/* <div className="piechart3d-total">
        Total: <strong>{activeTotal}</strong>
      </div>  */}
  return (
    <div>
      <Canvas
        className="PieChart3D"
        shadows
        colorManagement
        camera={{
          position: [0, 15, 15], // Slightly above + offset to show depth
          fov: 35,
          near: 0.1,
          far: 1000,
        }}
        gl={(gl) => {
          gl.toneMapping = THREE.NoToneMapping;
          gl.outputColorSpace = THREE.SRGBColorSpace;
        }}
      >
        <ambientLight intensity={1.3} />
        <directionalLight position={[0, 10, 5]} intensity={1.6} castShadow 
        shadow-mapSize-width={2048}
        shadow-mapSize-height={2048}
        shadow-camera-far={50}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}/>
        <pointLight position={[0, 10, 0]} intensity={1.5} />
        
        <mesh
          receiveShadow
          rotation={[-Math.PI / 2, 0, 0]}
          position={[0, 0, 0]}
        >
          <planeGeometry args={[100, 100]} />
          <shadowMaterial opacity={0.3} />
        </mesh>
        
{(() => {
  const enabledData = data
    .map((d, index) => ({ ...d, originalIndex: index }))
    .filter((d, index) => d.value > 0 && enabledSlices[index]);

  const enabledTotal = enabledData.reduce((sum, d) => sum + d.value, 0);
  let currentAngle = 0;
  const activeSliceCount = enabledData.length;

  return (
    <group rotation={[0, Math.PI / 2, 0]}> 
      {enabledData.map((slice, i) => {
        const angle = (slice.value / enabledTotal) * Math.PI * 2;

        const element = (
          <PieSlice
            key={slice.originalIndex}
            radius={radius}
            height={height}
            color={slice.color}
            angle={angle}
            startAngle={currentAngle}
            label={slice.label}
            value={slice.value}
            centerOffset={0.2}
            position={[0, 0, 0]}
            onClick={() => onSliceClick?.(slice)}
            onLabelClick={() => onLabelClick?.(slice)}
            gapAngle={activeSliceCount > 1 ? 0.05 : 0}
            index={i}
          />
        );

        currentAngle += angle;
        return element;
      })}
    </group>
  );
})()}

      </Canvas>

      <div className="piechart3d-legend">
        {data.map((slice, index) => {
          // if (slice.value <= 0) return null; //  Skip zero-value items
          return (
            <div
              key={index}
              onClick={() => toggleSlice(index)}
              className={`piechart3d-legend-item ${
                enabledSlices[index] ? "active" : "inactive"
              }`}
            >
              <span
                className="piechart3d-color-dot"
                style={{ backgroundColor: slice?.legendColor || slice?.color }}
              />
              <span className="piechart3d-label-text">
                {slice.label ?? `Slice ${index + 1}`}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
PieChart3D.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      color: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSliceClick: PropTypes.func,
  onLabelClick: PropTypes.func,
};

export default PieChart3D;





